import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 9a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2l0 -9","key":"svg-0"}],["path",{"d":"M16 3l-4 4l-4 -4","key":"svg-1"}]]

const IconDeviceTv = createReactComponent('outline', 'device-tv', 'DeviceTv', __iconNode);

export default IconDeviceTv;